/**
 * Facebook Ads audience integration
 * @module
 */
var VENDOR = 'facebook_ads';
var CAMPAIGN_ID_PARAM_NAME = 'opti_ca';
var AD_SET_ID_PARAM_NAME = 'opti_as';
var AD_ID_PARAM_NAME = 'opti_ad';
var TRACKING_IDENTIFIER = 'opti_source';
var VALUE_DELIMITER = ':';
var BrowserSource = require('core/utils/browser');



var pluginAudienceFacebook: AudiencePluginConfig = {
  provider: {
    getter: [
      'stores/visitor',
      function(VisitorStore) {
        var params = {} as any;
        var queryParams = BrowserSource.getQueryParams();
        var storedData = VisitorStore.getAttribute('vendor.' + VENDOR) ||
          {campaign: [], adset: [], ad: []};

        for (var i = 0; i < queryParams.length; i++) {
          params[queryParams[i][0]] = queryParams[i][1];
        }

        if (params[CAMPAIGN_ID_PARAM_NAME] && params[AD_SET_ID_PARAM_NAME] &&
            params[AD_ID_PARAM_NAME] && params[TRACKING_IDENTIFIER]) {
          if (params[TRACKING_IDENTIFIER] === 'fb') {
            // All IDs shall already be URI component encoded.
            var campaignId = params[CAMPAIGN_ID_PARAM_NAME];
            var adSetId = [params[CAMPAIGN_ID_PARAM_NAME], params[AD_SET_ID_PARAM_NAME]].join(VALUE_DELIMITER);
            var adId = [params[CAMPAIGN_ID_PARAM_NAME], params[AD_SET_ID_PARAM_NAME], params[AD_ID_PARAM_NAME]].join(VALUE_DELIMITER);
            if (storedData.campaign.indexOf(campaignId) === -1) {
              storedData.campaign.push(campaignId);
            }
            if (storedData.adset.indexOf(adSetId) === -1) {
              storedData.adset.push(adSetId);
            }
            if (storedData.ad.indexOf(adId) === -1) {
              storedData.ad.push(adId);
            }
            return storedData;
          }
        }
      },
    ]
  },
  matcher: require('core/plugins/matchers/key_value'),
  vendor: VENDOR,
};

module.exports = function(PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceFacebook);
};

if (__TEST__) {
  module.exports.plugin = pluginAudienceFacebook;
}

